import { useEffect, useState } from 'react';

// Header desktop chrome starts at 900px, matching Beacon treatment. Kept
// only for the JS branching that renders different components on mobile vs
// desktop (MenuPanel, AccountMenu); presentational responsiveness uses Tailwind
// `min-[900px]:` classes instead. Starts `false` so the server and first client
// render agree (hydration-safe), then resolves to the real match in an effect.
// Both branched components render hidden/closed content, so the pre-resolve frame
// has no visible effect regardless of viewport.
export const useLargerThanSM = (): boolean => {
  const [largerThanSM, setLargerThanSM] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const mediaQuery = window.matchMedia('(min-width: 900px)');
    const update = () => setLargerThanSM(mediaQuery.matches);
    update();
    mediaQuery.addEventListener('change', update);
    return () => mediaQuery.removeEventListener('change', update);
  }, []);

  return largerThanSM;
};
